import { defineMessages } from 'react-intl';

export default defineMessages({
    BuildingTitle: {
        id: 'quoteandbind.wizard.residential.Building',
        defaultMessage: 'Building'
    },
})